import { Entity, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import InventorySatellite from '../inventory-satellites/inventory-satellite.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';

@Entity('cm_categories')
export default class CmCategory extends InventorySatellite {
	static readonly tableName = 'cm_categories';

	@OneToMany((type) => EpisodicItem, (episodicItem) => episodicItem.category)
	episodicItems: EpisodicItem[];

	constructor(props?: GenPartial<CmCategory>) {
		super(props);
	}
}
